var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { useComponentConfig } from '../../providers/componentConfig';
import { COLOR } from '../../../theme/colors';
import { TYPOGRAPHY_TYPE, getTypographyStyles } from '../../../theme/typography';
export var LINK_SIZE;
(function (LINK_SIZE) {
    LINK_SIZE["SM"] = "sm";
    LINK_SIZE["MD"] = "md";
    LINK_SIZE["LG"] = "lg";
})(LINK_SIZE || (LINK_SIZE = {}));
const SIZE_TYPOGRAPHY_MAP = {
    [LINK_SIZE.SM]: TYPOGRAPHY_TYPE.CONTROL_SMALL,
    [LINK_SIZE.MD]: TYPOGRAPHY_TYPE.CONTROL_MEDIUM,
    [LINK_SIZE.LG]: TYPOGRAPHY_TYPE.CONTROL_LARGE,
};
export const Link = (_a) => {
    var { size, to, sx, target } = _a, rest = __rest(_a, ["size", "to", "sx", "target"]);
    const { link } = useComponentConfig();
    const typography = SIZE_TYPOGRAPHY_MAP[size || LINK_SIZE.MD];
    const InternalLink = link.internalLinkComponent;
    const ExternalLink = link.externalLinkComponent;
    const isExternal = link.externalMatcher.test(to);
    const styles = Object.assign(Object.assign({ color: COLOR.ND_BLUE_BRIGHT, textDecoration: 'none' }, getTypographyStyles(typography)), sx);
    if (isExternal) {
        return _jsx(ExternalLink, Object.assign({ to: to }, rest, { sx: styles, target: target }));
    }
    else {
        return _jsx(InternalLink, Object.assign({ to: to }, rest, { sx: styles, target: target }));
    }
};
